export interface Palette {
  primary: string;
  primarySoft: string;
  primaryDeep: string;
  background: string;
  card: string;
  text: string;
  textMuted: string;
  onPrimary: string;
  border: string;
  radius: number;
  radiusLg: number;
  font: string;
}

export const DEFAULT_FONT_STACK =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

export function hexWithAlpha(hex: string, alpha: number): string {
  if (!hex.startsWith('#')) return hex;
  const clean = hex.slice(1);
  const value = clean.length === 3 ? clean.split('').map((char) => char + char).join('') : clean;
  const red = parseInt(value.slice(0, 2), 16);
  const green = parseInt(value.slice(2, 4), 16);
  const blue = parseInt(value.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export function shadeColor(hex: string, amount: number): string {
  if (!hex.startsWith('#')) return hex;
  const clean = hex.slice(1);
  const value = clean.length === 3 ? clean.split('').map((char) => char + char).join('') : clean;
  const red = clampChannel(parseInt(value.slice(0, 2), 16) + Math.round(255 * amount));
  const green = clampChannel(parseInt(value.slice(2, 4), 16) + Math.round(255 * amount));
  const blue = clampChannel(parseInt(value.slice(4, 6), 16) + Math.round(255 * amount));
  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
}

function clampChannel(channel: number): number {
  return Math.max(0, Math.min(255, channel));
}

function toHex(channel: number): string {
  return channel.toString(16).padStart(2, '0');
}
